module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-2d291cf3.png";